export { default } from './ActivitatsPopulars';
